import React, { useMemo } from 'react'

import { API_URL } from '../constants'

import { useItems } from '../../hooks'

import FormField, { FIELD_TYPES } from '../../components/FormField'

import styles from './RolesCheckList.module.css'

const RolesCheckList = ({
  field: { label, name, defaultValue },
  item,
  onChange,
  value,
}) => {
  const [{ response: roles, isLoading, error }] = useItems(API_URL)

  const fields = useMemo(() => {
    if (isLoading || error || !roles) return null
    return {
      type: FIELD_TYPES.CHECKBOX_EXPIRATION_ARRAY,
      label: 'Roles',
      label2: 'Expiration',
      name,
      defaultValue,
      options: roles.map((p) => ({
        id: p.id,
        label: p.name,
      })),
    }
  }, [name, defaultValue, roles, isLoading, error])

  if (fields === null)
    return (
      <div>
        <label>{label}</label>
        <div>
          Loading Roles... <i className="fa fa-spinner fa-spin"></i>
        </div>
      </div>
    )

  return (
    <>
      <h4>{label}</h4>
      <div className={styles.listContainer}>
        <FormField field={fields} item={item} onChange={onChange} />
      </div>
    </>
  )
}

export default RolesCheckList
